<!--订单运营-->
<template>
    <div>
        <top-bar
            title="运营"
            :height="'48vh'"
            :isShowRefresh="false"
            icon="iconfont icon-yunying"
        />
        <v-container fluid class="mt-n6">
            <div class="handler">
                <div class="handler-card " v-for="(item, index) in label" :key="index">
                    <div
                        class="card"
                        :style="{
                            backgroundColor: theme.elementBgColor,
                        }"
                    >
                        <div
                            class="card-title center"
                            :style="{
                                fontSize: '1rem',
                                color: theme.pageFontColor,
                            }"
                        >
                            <div class="title-text center">{{ item.title }}</div>
                        </div>
                        <div
                            class="card-num center"
                            :style="{
                                fontSize: '1.5rem',
                                color: theme.pageFontColor,
                            }"
                        >
                            {{ item.nums }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="echarts-search" :style="{ backgroundColor: theme.elementBgColor }">
                <div class="search center">
                    <div class="refresh">
                        <v-btn text icon :loading="loading" @click="refresh()">
                            <v-icon>mdi-cached</v-icon>
                        </v-btn>
                    </div>
                    <div class="selectTime center">
                        <el-date-picker
                            v-model="time"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp"
                            style="width:100%"
                            :picker-options="pickerOptions"
                            @change="monthChange"
                        ></el-date-picker>
                    </div>
                </div>
                <div class="OrderMoneyEcharts center">
                    <order-money-echarts @search="search" />
                </div>
            </div>
        </v-container>
    </div>
</template>
<script>
import TopBar from "@/components/TopBar";
import SelectSite from "@/components/SelectSite";
import OrderMoneyEcharts from "@/components/Echarts/OrderMoneyEcharts";
import { mapState } from "vuex";
import store from "@/store";
import Public from "@/public";
export default {
    name: "OrderManageMent",
    data() {
        return {
            loading: false,
            time: [],
            selectSite: null,
            label: [
                {
                    icon: "iconfont icon-dingdan",
                    iconColor: "#42B983",
                    title: "订单数",
                    nums: 0,
                },
                {
                    icon: "iconfont icon-dianfei",
                    iconColor: "#1296db",
                    title: "营业额",
                    nums: 0,
                },
                {
                    icon: "iconfont icon-fuwufei",
                    iconColor: "#ff4d4f",
                    title: "电量",
                    nums: 0,
                },
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "昨天",
                        onClick(picker) {
                            const now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            console.log(lastData);
                            let start = new Date(lastData).getTime() - 8 * 60 * 60 * 1000;
                            let end = start + 23 * 3600 * 1000 + 59 * 60000 + 59 * 1000;
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 7);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 30);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 90);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    components: {
        SelectSite,
        OrderMoneyEcharts,
        TopBar,
    },
    computed: {
        ...mapState(["theme", "dayOrderSummary", "siteOrderSummary", "orderQuerySum"]),
    },
    mounted() {
        this.firstTimeData();
    },
    methods: {
        refresh() {
            this.loading = true;
            this.search();
        },
        monthChange(event) {
            console.log(event);
            if (!event) {
                return;
            }
            this.search();
        },
        firstTimeData() {
            this.loading = true;
            let dayTime = new Date();
            let Y = dayTime.getFullYear();
            let M = dayTime.getMonth() + 1;
            let D = dayTime.getDate();
            let end_time = Math.floor(dayTime.getTime());
            var datetime = Y + "-" + (M < 10 ? "0" + M : M) + "-" + (D < 10 ? "0" + D : D);
            let lw = new Date(dayTime - 1000 * 60 * 60 * 24 * 60);
            let lastY = lw.getFullYear();
            let lastM = lw.getMonth() + 1;
            let lastD = lw.getDate();
            let startThirtydate =
                lastY +
                "-" +
                (lastM < 10 ? "0" + lastM : lastM) +
                "-" +
                (lastD < 10 ? "0" + lastD : lastD);
            let beforeDate = new Date(startThirtydate + " 00:00:01");
            let start_time = Math.floor(beforeDate.getTime());
            this.time = [start_time, end_time];
            this.search();
        },
        /*搜索*/
        search() {
            if (this.time == null) {
                this.firstTimeData();
                return;
            }
            let start_time =
                new Date(Public.longDataToStr(this.time[0]).split(" ")[0]).getTime() -
                8 * 1000 * 3600;
            let end_time =
                new Date(Public.longDataToStr(this.time[1]).split(" ")[0]).getTime() -
                8 * 1000 * 3600 +
                24 * 3600 * 1000;
            // console.log(start_time);
            // console.log(end_time);
            // console.log(Public.longDataToStr(start_time));
            // console.log(Public.longDataToStr(end_time));
            this.getOrderSummary(start_time, end_time);
            this.getSiteOrderSummary(start_time, end_time);
        },
        async getOrderSummary(start_time, end_time) {
            let params = {
                postData: {
                    end_time: end_time / 1000,
                    start_time: start_time / 1000,
                    sum_type: 0,
                },
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
        },
        async getSiteOrderSummary(start_time, end_time) {
            let params = {
                postData: {
                    end_time: end_time / 1000,
                    start_time: start_time / 1000,
                },
                callback: () => {},
            };
            await store.dispatch("getOrderQuerySum", params);
            let data = JSON.parse(JSON.stringify(this.orderQuerySum));
            if (!data) {
                return;
            }
            this.label[0].nums = data["order_count"];
            this.label[1].nums = Public.addNum(data["sevice_money"], data["elec_money"]).toFixed(2);
            this.label[2].nums = data["total_power"].toFixed(2);
        },
    },
};
</script>
<style scoped>
.handler {
    width: 100%;
    height: 6.2rem;
    display: flex;
    flex-direction: row;
}
.handler-card {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card {
    width: 90%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 1.2rem;
}
.card-title {
    width: 100%;
    height: 40%;
}
.title-text {
    width: 80%;
    height: 100%;
    border-bottom: 1px solid #bcbcbc;
}
.card-num {
    width: 100%;
    height: 60%;
}
.echarts-search {
    width: 100%;
    height: 38rem;
    /* background-color: red; */
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    border-radius: 2rem;
}
.search {
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    flex-direction: row;
    position: relative;
}
.refresh {
    position: absolute;
    left: 2rem;
}
.selectTime {
    width: 40%;
    height: 100%;
}
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.OrderMoneyEcharts {
    width: 100%;
    height: 90%;
}
</style>
